import { render, staticRenderFns } from "./RevisaoAplicar.vue?vue&type=template&id=7296bfec&scoped=true"
import script from "./RevisaoAplicar.vue?vue&type=script&setup=true&lang=js"
export * from "./RevisaoAplicar.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7296bfec",
  null
  
)

export default component.exports